<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label=" Page iii. " class="page" epub:type="pagebreak" id="piii" role="doc-pagebreak"></span>What Is Critique? and The Culture of the Self</h1>
<p class="bkau">Michel Foucault</p>
<p class="bkau1">Edited by Henri-Paul Fruchaud, Daniele Lorenzini, and Arnold I. Davidson</p>
<p class="bkau1">Translated by Clare O’Farrell</p>
<p class="bkpub">The University of Chicago Press     Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-foucault-critique-0004.vue?0e4bae76